import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-bold" }
const _hoisted_2 = { class: "table table-striped" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        localizedKey: "Elementi duplicati nella prima importazione",
        text: "Elementi duplicati nella prima importazione"
      })
    ]),
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Origine",
              text: "Origine"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "OnOffice",
              text: "OnOffice"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Google",
              text: "Google"
            })
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Azione",
              text: "Azione"
            })
          ]),
          _hoisted_3
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock("tr", { key: i }, [
            _createElementVNode("td", null, _toDisplayString(item.firstSyncOrigin), 1),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.onOfficeEvents, (ev, i) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.date(ev.startDate, "DD/MM/yyyy HH:mm")) + " - " + _toDisplayString(_ctx.$filters.date(ev.endDate, "DD/MM/yyyy HH:mm")), 1),
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(ev.title), 1)
                ]))
              }), 256))
            ]),
            _createElementVNode("td", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.googleEvents, (ev, i) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  (ev.start.date)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(ev.start.date, "DD/MM/yyyy HH:mm")) + " - " + _toDisplayString(_ctx.$filters.date(ev.end.date, "DD/MM/yyyy HH:mm")), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(ev.start.dateTime, "DD/MM/yyyy HH:mm")) + " - " + _toDisplayString(_ctx.$filters.date(ev.end.dateTime, "DD/MM/yyyy HH:mm")), 1)
                      ], 64)),
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(ev.title), 1)
                ]))
              }), 256))
            ]),
            _createElementVNode("td", null, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: ($event: any) => (_ctx.doAction(item, 'KeepOnOffice'))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Tieni onOffice, elimina google",
                    text: "Tieni onOffice, elimina google"
                  })
                ], 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: ($event: any) => (_ctx.doAction(item, 'KeepGoogle'))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Tieni google, elimina onOffice",
                    text: "Tieni google, elimina onOffice"
                  })
                ], 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  class: "btn btn-danger",
                  onClick: ($event: any) => (_ctx.doAction(item, 'KeepNone'))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Elimina entrambi",
                    text: "Elimina entrambi"
                  })
                ], 8, _hoisted_10)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}